import Ann from "../../assets/combatants/na-toons/kimPossible/ann.png";
import AnnIcon from "../../assets/combatants/na-toons/kimPossible/ann-icon.png";
import AnnWin from "../../assets/combatants/na-toons/kimPossible/ann-win.png";
import AnnLose from "../../assets/combatants/na-toons/kimPossible/ann-lose.png";

import Bonnie from "../../assets/combatants/na-toons/kimPossible/bonnie.png";
import BonnieIcon from "../../assets/combatants/na-toons/kimPossible/bonnie-icon.png";
import BonnieWin from "../../assets/combatants/na-toons/kimPossible/bonnie-win.png";
import BonnieLose from "../../assets/combatants/na-toons/kimPossible/bonnie-lose.png";

import Kim from "../../assets/combatants/na-toons/kimPossible/kim.png";
import KimIcon from "../../assets/combatants/na-toons/kimPossible/kim-icon.png";
import KimWin from "../../assets/combatants/na-toons/kimPossible/kim-win.png";
import KimLose from "../../assets/combatants/na-toons/kimPossible/kim-lose.png";

import Shego from "../../assets/combatants/na-toons/kimPossible/shego.png";
import ShegoIcon from "../../assets/combatants/na-toons/kimPossible/shego-icon.png";
import ShegoWin from "../../assets/combatants/na-toons/kimPossible/shego-win.png";
import ShegoLose from "../../assets/combatants/na-toons/kimPossible/shego-lose.png";

export const seriesId = "Kim Possible";

export default {
  ann: {
    seriesId,
    id: "ann",
    name: "Ann Possible",
    description:
      "Dr. Ann Possible is a neurosurgeon who lives and works in Middleton. She is a devoted wife and mother.",
    img: Ann,
    icon: AnnIcon,
    opWinImg: AnnWin,
    opLoseImg: AnnLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "buxom",
    eyeColor: "blue",
    hairColor: "red",
    skinColor: "fair",
    height: 2,
    penisSize: 0,
    breastSize: 3,
    vaginaSize: 2,
    anusSize: 3,
    throatSize: 2,
    // Pref properties effect 'AI'
    prefAttack: "tongue",
    prefTarget: "mouth",
    uniqueAttackText:
      "Ann pushes her heavy tongue into xxxx's mouth, tasting her delicious mouth.",
    roughPlayLvl: 10, // how responds to domination either -hates or +likes
    // Prowess is capability
    seductionResistance: 25,
    grapplingProwess: 35,
    tongueProwess: 34,
    touchProwess: 28,
    cockProwess: 25,
    vaginaProwess: 20,
    anusProwess: 15,
    // -- resistance is ability to endure pleasure, 1 - 100
    touchResistance: 25,
    breastResistance: 40,
    mouthResistance: 20,
    cockResistance: 25,
    vaginaResistance: 25,
    anusResistance: 18,
    orgasmLimit: 3,
  },
  bonnie: {
    seriesId,
    id: "bonnie",
    name: "Bonnie Rockwaller",
    description:
      "Bonnie Rockwaller is Kim Possible's Middleton High School classmate, fellow cheerleader, and her archrival since at least middle school.",
    img: Bonnie,
    icon: BonnieIcon,
    opWinImg: BonnieWin,
    opLoseImg: BonnieLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "busty",
    eyeColor: "teal",
    hairColor: "brown",
    skinColor: "light tan",
    height: 2,
    penisSize: 0,
    breastSize: 2,
    vaginaSize: 2,
    anusSize: 2,
    throatSize: 3,
    prefAttack: "tongue",
    prefTarget: "touch",
    uniqueAttackText:
      "Bonnie hungry licks xxxx's skin, covering them in saliva, and savouring their taste.",
    roughPlayLvl: 5,
    seductionResistance: 25,
    grapplingProwess: 35,
    tongueProwess: 25,
    touchProwess: 35,
    cockProwess: 20,
    vaginaProwess: 30,
    anusProwess: 15,
    touchResistance: 15,
    breastResistance: 20,
    mouthResistance: 34,
    cockResistance: 30,
    vaginaResistance: 25,
    anusResistance: 25,
    orgasmLimit: 3,
  },
  kim: {
    seriesId,
    id: "kim",
    name: "Kim Possible",
    description:
      "Kimberly Ann 'Kim' Possible is a high school student and freelance hero/vigilante.",
    img: Kim,
    icon: KimIcon,
    opWinImg: KimWin,
    opLoseImg: KimLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "youthful",
    eyeColor: "green",
    hairColor: "red",
    skinColor: "pale",
    height: 1,
    penisSize: 0,
    breastSize: 1,
    vaginaSize: 1,
    anusSize: 1,
    throatSize: 1,
    prefAttack: "touch",
    prefTarget: "touch",
    uniqueAttackText:
      "Kim smothers her opponent with her soft and youthful body, tickling xxxx with her small, cute nipples.",
    roughPlayLvl: 5,
    seductionResistance: 40,
    grapplingProwess: 50,
    tongueProwess: 35,
    touchProwess: 35,
    cockProwess: 25,
    vaginaProwess: 45,
    anusProwess: 45,
    touchResistance: 45,
    breastResistance: 25,
    mouthResistance: 35,
    cockResistance: 25,
    vaginaResistance: 35,
    anusResistance: 45,
    orgasmLimit: 3,
  },
  shego: {
    seriesId,
    id: "shego",
    name: "Shego",
    description:
      "Shego is a villainess who works for Dr. Drakken as his 'sidekick'.",
    img: Shego,
    icon: ShegoIcon,
    opWinImg: ShegoWin,
    opLoseImg: ShegoLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "curvaceous",
    eyeColor: "GREEN",
    hairColor: "black",
    skinColor: "pale green",
    height: 2,
    penisSize: 0,
    breastSize: 3,
    vaginaSize: 2,
    anusSize: 2,
    throatSize: 2,
    prefAttack: "tongue",
    prefTarget: "cock",
    uniqueAttackText:
      "Shego impales herself on xxxx's thick meat pole, gagging on it roughly.",
    roughPlayLvl: 12,
    seductionResistance: 35,
    grapplingProwess: 40,
    tongueProwess: 40,
    touchProwess: 20,
    cockProwess: 25,
    vaginaProwess: 15,
    anusProwess: 25,
    touchResistance: 35,
    breastResistance: 25,
    mouthResistance: 35,
    cockResistance: 25,
    vaginaResistance: 30,
    anusResistance: 25,
    orgasmLimit: 3,
  },
};
